import { ShaderMaterial, Uniform, Vector2, Vector4 } from 'three'

import fragment from './shader-fragment.glsl'
import vertex from './shader-vertex.glsl'

export default class GlitchMaterial extends ShaderMaterial
{
    constructor(options = {})
    {
        super({
            type: 'GlitchMaterial',

            uniforms:
            {
                tDiffuse: new Uniform(null),
                tGradient: new Uniform(null),

                uTime: new Uniform(0),

                uTileProgressVertical: new Uniform(0),
                uTileProgressHorizontal: new Uniform(0),
                uTileAmplitude: new Uniform(0),
                uTileOffset: new Uniform(new Vector2(0, 0)),
                uTileFrequency: new Uniform(new Vector2(1, 1)),

                uWaveProgress: new Uniform(0),
                uWaveAmplitude: new Uniform(0),
                uWaveStrength: new Uniform(new Vector2(0, 0)),

                uGradientProgress: new Uniform(0),
                uGradientOffset: new Uniform(0),
                uGradientAmplitude: new Uniform(0),

                uBlueProgress: new Uniform(0),
                uBlueAmplitude: new Uniform(0),

                uSaturation: new Uniform(0),

                uWhiteTileChances: new Uniform(0),
                uWhiteTileFrequency: new Uniform(0),
                uWhiteTileStrength: new Uniform(0)
            },

            fragmentShader: fragment,
            vertexShader: vertex,

            depthWrite: false,
            depthTest: false
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/Passes/GlitchPass/Material.js